import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { GlobalServices } from 'app/services/global.service';
import { MemberTypes } from 'app/models/ss-api/responses/login.response';
import { CreditCardTypes } from 'app/models/ss-api/responses/credit.card.response';
import { CreditCardHelper } from 'app/helpers/creditcard';
// import * as $ from 'jquery';

// window['jQuery'] = $;

@Component({
    selector: 'ss-cc-form',
    templateUrl: './ss-cc-form.component.html',
    styleUrls: ['./ss-cc-form.component.scss']
})
export class SSCreditCardFormComponent implements OnInit {

    @ViewChild('ccNumber') ccNumber: ElementRef;

    @Input('form') form: UntypedFormGroup;

    @Output('onFormChanged') onFormChanged: EventEmitter<any>;

    ccardForm: UntypedFormGroup;
    ccardType: number;

    isMember: boolean;

    Year: number = new Date().getFullYear();
    YearRange: any[] = [];
    SelectedYear;

    constructor(private _fb: UntypedFormBuilder, private gb : GlobalServices) { }

    ngOnInit() {
        // SET UP YEAR RANGE FOR CREDIT CARD EXPIRATION DATE FIELD
        for (let i: number = 0; i < 15; i++) {
            this.YearRange.push(this.Year + i);
        }

        this.isMember = this.gb.MemberType == MemberTypes.Member;

        this.onFormChanged = new EventEmitter();

        let disposable = this.form.valueChanges.subscribe(response => {
            this.CheckCredtiCardType(response.creditCard);
            this.onFormChanged.emit(response);
        });
    }

    CheckCredtiCardType( value : string ) {
        
        console.log("Credit Card Value : " + value);
        let cardType : CreditCardTypes = CreditCardHelper.GetCardTypes( value );
        this.ccardType = cardType;

    }

    isValidExpiration() {
        let ccExpMonth = this.form.get('expMonth').value;
        let ccExpYear = this.form.get('expYear').value;

        if (moment(ccExpMonth + '/' + ccExpYear, 'MM/YYYY').isSameOrAfter(moment(moment().format('MM/YYYY'), 'MM/YYYY'))) {
            return true;
        } else {
            return false;
        }
    }

}
